<template>
  <div class="privacy-page">
    <navbar
      is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
      btn-background="bg-gradient-success"
      :dark-mode="true"
    />
    
    <!-- Hero Section avec design similaire -->
    <section class="privacy-hero" style="padding-top: 140px; padding-bottom: 80px; background: #FFFFFF;">
      <div class="container">
        <div class="row align-items-center">
          <!-- Contenu gauche -->
          <div class="col-lg-6">
            <h1 class="privacy-title mb-4">
              Politiques de confidentialité
              <svg class="title-underline" viewBox="0 0 300 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 4C60 2 240 2 298 6" stroke="#F5A847" stroke-width="3" stroke-linecap="round"/>
              </svg>
            </h1>
            
            <p class="privacy-text mb-4" style="color: #8B8B8B; font-size: 0.95rem; line-height: 1.7;">
              Chez Nolido Cash, nous accordons une grande importance à la protection de vos données personnelles. Notre politique de confidentialité détaille comment nous collectons, utilisons, partageons et protégeons vos informations.
            </p>
            
            <h5 class="mt-5 mb-3" style="color: #2F2113; font-weight: 700;">1. Collecte des données</h5>
            <p class="privacy-text mb-4">
              Nous collectons uniquement les données nécessaires au bon fonctionnement de nos services. Ces données peuvent inclure vos informations d'identification (nom, prénom, email), données professionnelles (société, fonction), données techniques (adresse IP, cookies) et données d'utilisation de nos services.
            </p>
            
            <h5 class="mt-5 mb-3" style="color: #2F2113; font-weight: 700;">2. Utilisation des données</h5>
            <p class="privacy-text mb-4">
              Vos données sont utilisées pour fournir et améliorer nos services, personnaliser votre expérience, communiquer avec vous et assurer la sécurité de nos plateformes.
            </p>
            
            <h5 class="mt-5 mb-3" style="color: #2F2113; font-weight: 700;">3. Protection des données</h5>
            <p class="privacy-text mb-4">
              Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles robustes pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.
            </p>
            
            <h5 class="mt-5 mb-3" style="color: #2F2113; font-weight: 700;">4. Vos droits</h5>
            <p class="privacy-text mb-4">
              Conformément au RGPD, vous disposez des droits d'accès, de rectification, d'effacement, de limitation du traitement, de portabilité des données et d'opposition. Pour exercer ces droits, contactez notre délégué à la protection des données à dpo@nolido.com.
            </p>
            
            <div class="d-flex align-items-center mt-5" style="color: #8B8B8B; font-size: 0.85rem;">
              <i class="bi bi-clock-history me-2"></i>
              <span><strong>Dernière mise à jour :</strong> 30 Juillet 2023</span>
            </div>
          </div>
          
          <!-- Image iPhone droite -->
          <div class="col-lg-6 text-center">
            <div class="phone-mockup-container">
              <img :src="require('@/assets/img/iphone.png')" alt="Nolido App" class="phone-mockup-privacy">
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- Composants requis -->
    <testimonials-section />
    <faq-section />
    <cta-section />
    <app-footer />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import TestimonialsSection from '@/components/TestimonialsSection.vue';
import FaqSection from '@/components/FaqSection.vue';
import CtaSection from '@/components/CtaSection.vue';

export default {
  name: 'PrivacyPage',
  components: {
    Navbar,
    AppFooter,
    TestimonialsSection,
    FaqSection,
    CtaSection
  }
}
</script>

<style scoped>
.privacy-page {
  background: #FFFFFF;
}

.privacy-hero {
  min-height: 80vh;
  display: flex;
  align-items: center;
}

.privacy-title {
  font-size: 3rem;
  font-weight: 800;
  color: #2F2113;
  line-height: 1.2;
  position: relative;
  display: inline-block;
  margin-bottom: 2rem;
}

.title-underline {
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 100%;
  max-width: 300px;
  height: auto;
}

.privacy-text {
  font-size: 0.95rem;
  color: #8B8B8B;
  line-height: 1.7;
}

.phone-mockup-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.phone-mockup-privacy {
  max-width: 400px;
  width: 100%;
  height: auto;
  filter: drop-shadow(0 20px 60px rgba(0,0,0,0.2));
}

@media (max-width: 992px) {
  .privacy-title {
    font-size: 2.5rem;
  }
  
  .privacy-hero {
    padding-top: 100px;
    padding-bottom: 60px;
  }
  
  .phone-mockup-privacy {
    max-width: 300px;
    margin-top: 3rem;
  }
}

@media (max-width: 768px) {
  .privacy-title {
    font-size: 2rem;
  }
  
  .privacy-text {
    font-size: 0.9rem;
  }
  
  .phone-mockup-privacy {
    max-width: 250px;
  }
}
</style>